

class LocationNotAssociatedController {
	/*@ngInject*/
	constructor(Auth, $state, $stateParams, User, Modal, $translate, $location, UserService, BranchService, $q, $scope, FuelSurchargeService, Navigation) {
		this.Auth = Auth;
		this.User = User;
		this.Modal = Modal;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.$q = $q;
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.permissions = this.Auth.permission();
		this.loading = false;
		this.locations = [];
		this.FuelSurchargeService = FuelSurchargeService;
		this.sortColumn = 'locationName';
		this.reverseSort = 0;
		this.page = 1
		this.total = 0
		this.pageLimit = 10
		this.maxPages = 10
		this._objectKeys = Object.keys;
		this.searchText = '';
		this.Navigation = Navigation;
	}

	icon = {
		'REGULAR': 'regular.png',
		'ATM': 'atm.png',
		'BANK': 'bank.png',
		'NO_SHIP_NO_GO': 'nsng.png',
		'INTERNAL': 'internal.png',
		'TRUCK': 'truck.png',
		'TANKER': 'tanker.png',
		'WINDOW': 'window.png',
		'ON_CALL': 'oncall.png',
		'CARRIER': 'carrier.png',
		'LOCKER': 'locker.png',
		'VAULT': 'vault.png',
		'DELIVERY': 'delivery.png'
	}

	loadImage = function (image) {
		let imgURL = this.icon[image]
		// return require('../../../assets/images/' + imgURL);
		return require('../../../../../assets/images/' + imgURL);
	}

	$onInit() {
		this.loadLocations()
	}

	search() {
		this.page = 1;
		this.loadLocations()
	}
	refresh() {
		this.loadLocations()
	}

	sortData(column) {
		this.page = 1;
		this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
		this.sortColumn = column;
		this.loadLocations()
	}
	goToLocation = (locationId) => {
		this.Navigation.goToLocationTab(locationId);
	}

	goToCustomer = (customerId) => {
		this.$state.go('customer.edit', ({
			id: customerId
		}))
	}

	loadLocations() {
		this.loading = true;
		this.locations = [];
		this.FuelSurchargeService.fuelSurchagePendingLocationsFilters(this.searchText, (this.page - 1) * this.pageLimit, this.pageLimit, this.sortColumn, this.reverseSort)
			.then(({ data, count }) => {
				this.total = count;
				this.locations = data;
				this.loading = false;
			})
			.catch((err) => {
				this.loading = false
				this.error = err.message
			})
	}
}

export default LocationNotAssociatedController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/location_not_associated/location_not_associated.controller.js